import type { ReactElement } from 'react';
import { useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { Button } from '../../../../ui-kit/Button/Button';
import { Card } from '../../../../ui-kit/Card/Card';
import { ProgressBar } from '../../../../ui-kit/ProgressBar/ProgressBar';
import { UploadState, type UploadItem } from '../model/uploads';
import styles from './UploadList.module.scss';

const STATE_BADGE = {
  [UploadState.Uploading]: { tone: 'neutral', key: 'media.uploads.uploading' },
  [UploadState.Done]: { tone: 'success', key: 'media.uploads.done' },
  [UploadState.Duplicate]: { tone: 'warning', key: 'media.uploads.duplicate' },
  [UploadState.Failed]: { tone: 'danger', key: 'media.uploads.failed' },
} as const;

/** MED-UC-1, MED-UC-1.CC-1, MED-UC-1.CC-2: очередь загрузок с прогрессом и итогом по каждому файлу. */
export function UploadList({ items, onClear }: { items: readonly UploadItem[]; onClear(): void }): ReactElement | null {
  const { t, te } = useT();
  if (items.length === 0) return null;
  return (
    <Card
      title={t('media.uploads.title')}
      actions={
        <Button size="sm" variant="ghost" onClick={onClear}>
          {t('media.uploads.clear')}
        </Button>
      }
    >
      <ul className={styles.list} aria-live="polite">
        {items.map((item) => (
          <li key={item.id} className={styles.item} data-testid="upload-item">
            <div className={styles.head}>
              <span className={styles.name}>{item.name}</span>
              <Badge tone={STATE_BADGE[item.state].tone}>{t(STATE_BADGE[item.state].key)}</Badge>
            </div>
            {item.state === UploadState.Uploading ? <ProgressBar value={item.progress} label={t('media.uploads.progress', { name: item.name })} /> : null}
            {item.error ? <span className={styles.error}>{te(item.error)}</span> : null}
          </li>
        ))}
      </ul>
    </Card>
  );
}
